module.exports = __webpack_public_path__ + "static/img/产品中心-AI融合管理平台-主辅运输.31083664.png";